export default {
  path: '/retrieve-change',
  meta: {
    title: '修改密码',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/retrieve`),
}



// WEBPACK FOOTER //
// ./src/views/changePSW/router.js